// src/constants/logicalPlot.ts
// PLOT_JP座標テーブル（words4cards20121217.xls / PLOT_JP シートより）
// X（ヨコ）: -10〜+10、Y（タテ）: -10〜+10
// 横軸: 静的（左）←→ 動的（右）
// 縦軸: 深める（下）←→ 広げる（上）

export interface PlotCoord {
  x: number; // ヨコ: 左（-）= 静的、右（+）= 動的
  y: number; // タテ: 上（+）= 広げる、下（-）= 深める
  suit: string;
}

// キー: カードのtextフィールドと完全一致
export const LOGICAL_PLOT: Record<string, PlotCoord> = {
  // ♠ スート（Y正・X負：上×左象限）
  "おそらく":       { x: -5,  y:  1,  suit: "♠" },
  "現在":           { x: -6,  y:  4,  suit: "♠" },
  "事実上":         { x: -3,  y:  7,  suit: "♠" },
  "今のところ":     { x: -8,  y:  6,  suit: "♠" },
  "特に":           { x: -4,  y:  6,  suit: "♠" },
  "現実的には":     { x: -6,  y:  6,  suit: "♠" },
  "実際":           { x: -6,  y:  8,  suit: "♠" },
  "事実":           { x: -8,  y:  8,  suit: "♠" },
  "たとえば":       { x: -5,  y:  9,  suit: "♠" },
  "正確には":       { x: -7,  y:  9,  suit: "♠" },
  "詳しくは":       { x: -9,  y:  9,  suit: "♠" },
  "具体的には":     { x: -5,  y: 10,  suit: "♠" },
  "厳密には":       { x: -8,  y: 10,  suit: "♠" },

  // ♣ スート（Y正・X正：上×右象限）
  "さもなければ":   { x:  7,  y:  1,  suit: "♣" },
  "または":         { x:  5,  y:  2,  suit: "♣" },
  "一方":           { x:  6,  y:  2,  suit: "♣" },
  "対照的に":       { x:  8,  y:  3,  suit: "♣" },
  "そして":         { x:  5,  y:  5,  suit: "♣" },
  "同様に":         { x:  6,  y:  5,  suit: "♣" },
  "同時に":         { x:  6,  y:  6,  suit: "♣" },
  "それに":         { x:  4,  y:  7,  suit: "♣" },
  "しかも":         { x:  3,  y:  8,  suit: "♣" },
  "できれば":       { x:  9,  y:  8,  suit: "♣" },
  "偶然にも":       { x:  6,  y:  9,  suit: "♣" },
  "ちなみに":       { x:  5,  y: 10,  suit: "♣" },
  "もし":           { x: 10,  y: 10,  suit: "♣" },

  // ♦ スート（Y負・X正：下×右象限）
  "さて":           { x:  6,  y: -1,  suit: "♦" },
  "では":           { x:  3,  y: -2,  suit: "♦" },
  "とにかく":       { x: 10,  y: -2,  suit: "♦" },
  "だから":         { x:  4,  y: -3,  suit: "♦" },
  "したがって":     { x:  5,  y: -3,  suit: "♦" },
  "こうして":       { x:  7,  y: -3,  suit: "♦" },
  "それでも":       { x:  3,  y: -4,  suit: "♦" },
  "ついに":         { x: 10,  y: -4,  suit: "♦" },
  "にもかかわらず": { x:  4,  y: -5,  suit: "♦" },
  "結局":           { x: 10,  y: -5,  suit: "♦" },
  "言うまでもなく": { x:  8,  y: -6,  suit: "♦" },
  "しかし":         { x:  3,  y: -7,  suit: "♦" },
  "ところが":       { x:  3,  y: -8,  suit: "♦" },

  // ♥ スート（Y負・X負：下×左象限）
  "そういう意味で": { x: -2,  y: -2,  suit: "♥" },
  "通常":           { x: -3,  y: -3,  suit: "♥" },
  "基本的に":       { x: -3,  y: -4,  suit: "♥" },
  "つまり":         { x: -7,  y: -4,  suit: "♥" },
  "言い換えると":   { x: -7,  y: -5,  suit: "♥" },
  "なにせ":         { x: -10, y: -5,  suit: "♥" },
  "歴史的には":     { x: -3,  y: -6,  suit: "♥" },
  "要するに":       { x: -8,  y: -6,  suit: "♥" },
  "もともと":       { x: -3,  y: -7,  suit: "♥" },
  "むしろ":         { x: -5,  y: -7,  suit: "♥" },
  "一般的には":     { x: -2,  y: -8,  suit: "♥" },
  "本質的に":       { x: -2,  y:-10,  suit: "♥" },
  "なぜなら":       { x:-10,  y:-10,  suit: "♥" },

  // JOKER
  "それはさておき": { x: -1,  y: 10,  suit: "joker" },
  "残念ながら":     { x:-10,  y: -7,  suit: "joker" },
};

/** 語テキストからPlotCoordを返す。未登録語はnullを返す */
export function getLogicalPlot(text: string): PlotCoord | null {
  return LOGICAL_PLOT[text] ?? null;
}
